export default "__VITE_ASSET__BL5ey945__"